import "./Home.css";
// import "./Banner/Banner.jsx";
import { Banner } from "./Banner/Banner.jsx";
import { Products } from "../Products/Products.jsx";
import { Category } from "./Category/Category.jsx";
import { useContext, useEffect } from "react";
import { fetchDataFromApi } from "../../utils/api.js";
import { Context } from "../../utils/context.js";
export function Home(){

    const {categories, setCategories, products, setProducts} = useContext(Context);

    useEffect(()=>{
       getCategories()
       getProducts();
    },[]);

    function getProducts(){
        fetchDataFromApi("/api/products?populate=*").then(res => {
            console.log(res);
            setProducts(res);
        })
    }
    function getCategories(){
        fetchDataFromApi("/api/categories?populate=*").then(res => {
            console.log(res);
            setCategories(res);
        })
    }

    

    return(
        <div>
           {/* <Banner /> */}
           <Banner />
           <div className="main-content">
            <div className="layout">
            <Category categories={categories} />
            <Products products={products} headingText="Popular Products" />
            </div>
           </div>
        </div>
    )
}